import * as _ from "lodash";
import * as angular from "angular";
import {ILogService, IScope} from "angular";
import {StateService} from "@uirouter/angularjs";
import {IModalService} from "angular-ui-bootstrap";
import {PriorCourseUnit} from "../model/PriorCourseUnit";
import {PriorCourse} from "../model/PriorCourse";
import {MonashCourse} from "../model/MonashCourse";
import {Application} from "../model/Application";
import {User} from "../model/User";
import {Assessment} from "../model/Assessment";
import {Applicant} from "../model/Applicant";
import {WidgetEnabledState} from "../model/WidgetEnabledState";
import {ApplicationService} from "./application.service";
import {ChatService} from "../chat/chat.service";
import {LoadingService} from "../loading/loading.service";
import {FacultyService} from "../faculty/faculty.service";
import {isSystemAccepted as checkSystemAccepted, isSystemRejected as checkSystemRejected} from "../model/ApplicationStatusUtil";
import "./form/application-form.less";
import {CreditSummary} from "../model/CreditSummary";

export interface ApplicationControllerScope extends IScope {
    vm: ApplicationController;
}

class ApplicationController {
    public form: any;
    public firebaseDatabasePath: string;
    public asideContent: string;
    public processing;
    public showErrors = false;
    public invalidCampus = false;
    public invalidCourse = false;
    public editDisabled = false;
    public assessmentActionsEnabled: boolean = false;
    public newInstitutionAlertShown: boolean;
    public isUploading = false;
    public debug: boolean = false;
    public supportingDocuments: any[] = [];
    public attachments = [];
    public supportingDocumentsQueue: any[] = [];
    public internalUseOnlyDocuments: any[] = [];
    public internalUseOnlyDocumentsQueue: any[] = [];
    public unitDocumentsQueue = {};
    public unitDocumentsNewAttachments = {};

    public applyingFor: any;
    public applyingForCredit: boolean = false;
    public applyingForPreclusion: boolean = false;

    public application: Application;

    public selectedCourseCode: string;
    public currentCourses: any[];
    public applicationCourseOfferStatus: string;
    public applicationHistories: any[];
    public currentUser: User;
    public previousApplications: Application[];
    public linksValid: boolean;
    public linksFormatValid: boolean;
    public appliedCourseValid: boolean;
    public selectedCourse: any;
    public linkIndexArray: any[] = [1, 2, 3, 4, 5];

    // Assessments and related vars
    public assessments: Assessment[];
    public approvedAssessmentsCreditSummary: CreditSummary[];
    public creditPointsApproved: number;
    public creditPointsAccepted: number;
    public studentMode = false;
    public isAllowAddCoursesByStudent  = false;
    /* @ngInject */
    constructor(private $log: ILogService,
                private $scope: ApplicationControllerScope,
                private $uibModal: IModalService,
                private applicationService: ApplicationService,
                private facultyService: FacultyService,
                private loadingService: LoadingService,
                private $state: StateService,
                private toaster: any,
                private chatService: ChatService) {
    }

    public $onInit() {
        this.linksValid = true;
        this.linksFormatValid = true;
        this.appliedCourseValid = true;

        if (this.application == null) {
            this.application = new Application();
            this.application.applicant = Applicant.fromUser(this.currentUser);
            // this.application.coursesApplied = _.cloneDeep(this.currentCourses);

        } else {
            Application.initValues(this.application);
            // Auto-select if there is only one eligible (non-duplicated) course
            if (!this.application.status && this.currentCourses) {
                const eligibleCourses = this.currentCourses.filter(c => !c.course.isDuplicated);
                if (eligibleCourses.length == 1 && (!this.application.coursesApplied || this.application.coursesApplied.length == 0)) {
                    this.application.coursesApplied.push(eligibleCourses[0]);
                    this.selectedCourseCode = eligibleCourses[0].code;
                }
            }
            if (this.application.coursesApplied.length > 0) {
                this.selectedCourseCode = this.application.coursesApplied[0].courseCode;
            }
        }
        this.$log.debug(this.application);
        // if ((this.currentUser.isStaff && !(this.$state.current.name === "staff.create") && !(this.$state.current.name === "staff.edit")) ||
        //     (this.application.status && this.application.status !== "DRAFTED" && this.application.status !== "REOPENED")) {
        //     this.editDisabled = true;
        // }
        // if a student open his application whose status is DRAFT/REOPENED, the student is allowed to edit this application
        if ((!this.application.status || (this.application.status && (this.application.status === "DRAFTED" || this.application.status === "REOPENED"))) && this.studentMode) {
            this.editDisabled = false;
            this.isAllowAddCoursesByStudent = true;
        // if a staff creates/edits an application, the staff is able to edit the application
        } else if ( this.currentUser.isStaff && (this.$state.current.name === "staff.create"  || this.$state.current.name === "staff.edit" ) ) {
            this.editDisabled = false;
        } else {
            this.editDisabled = true;
            this.isAllowAddCoursesByStudent = false;
        }

        if (!this.application.supportingLinks) {
            this.application.supportingLinks = [];
        }

        if (this.application.status !== "STUDENT_ACCEPTED" && this.application.status !== "STUDENT_DECLINED") {
            this.assessmentActionsEnabled = true;
        }

        this.newInstitutionAlertShown = this.application.priorStudies.reduce((previous, priorStudy: PriorCourse) => {
            return previous || !priorStudy.institution;
        }, false);

        this.asideContent = "ASSESSMENTS";

        this.firebaseDatabasePath = `${this.chatService.APPLICATION_MESSAGES_ROOT_PATH}/${this.application.id}`;
        this.$log.debug(`Previous applications for user: ${this.previousApplications && this.previousApplications.length}`);

        this.updateCreditPoints();
    }


    public assessPriorStudiesClick() {
        if (this.application.assessPriorStudies) {
            this.addPriorStudy(null);
        }
    }



    public changeCoursesApplied(checkedCode: string) {
        // add the course if it is not existed in courseApplied
        if (this.application.coursesApplied.filter(c => c.courseCode == checkedCode).length == 0) {
            const course = this.currentCourses.forEach(currentCourse => {
                if (currentCourse.courseCode == checkedCode) {
                    this.application.coursesApplied.push(currentCourse)
                }
            });
        } else {
            // remove the course if it is already in the applied course list
            this.application.coursesApplied = this.application.coursesApplied.filter(c => c.courseCode != checkedCode);
        }
        console.log(this.application.coursesApplied);
    }

    public onCourseSelected(selectedCode: string) {
        // Clear and set exactly one course for single-select radio behavior
        this.application.coursesApplied = [];
        this.currentCourses.forEach(currentCourse => {
            if (currentCourse.courseCode == selectedCode) {
                this.application.coursesApplied.push(currentCourse);
            }
        });
        this.selectedCourseCode = selectedCode;
    }

    public addEditUnit(priorCourse: PriorCourse, unit?: PriorCourseUnit) {

        if (priorCourse !== undefined && priorCourse !== null) {
            priorCourse.index = this.application.priorStudies.indexOf(priorCourse);
        }

        const modalInstance = this.$uibModal.open({
            component: "addUnitComponent",
            backdrop: 'static',
            keyboard: false,
            resolve: {
                application: () => this.application,
                priorCourse: () => priorCourse,
                priorUnit: () => unit
            },
            size: "lg"
        }).result.then((course: PriorCourse) => {

            this.application.priorStudies[course.index] = course;
            this.savePriorStudies();

        }, (reason) => {
            this.$log.info("modal dismissed: " + reason);
        });
    }

    public savePriorStudies() {
        this.loadingService.show();
        this.applicationService.updatePriorStudies(this.application.id, this.application.priorStudies, this.application.assessPriorStudies)
            .then((updatedApplication) => {
                this.$log.debug("updatedApplication", updatedApplication);
                this.toaster.pop({type: "Success", title: "Prior course updated"});
                this.application = updatedApplication;
            })
            .catch((reason) => {
                this.$log.debug("Failed", reason);
                this.toaster.pop({type: "failure", title: "Failed to update the prior course "});
            })
            .finally(() => {
                this.processing = false;
                this.loadingService.hide();
            });

    }


    public deletePriorStudy(c: PriorCourse) {
        if (confirm("Are you sure you wish to delete?")) {
            this.application.priorStudies.splice(this.application.priorStudies.indexOf(c), 1);
            this.savePriorStudies();
        }
    }

    public addPriorStudy(c: PriorCourse) {
        if (this.application.priorStudies === undefined) {
            this.application.priorStudies = [];
        }

        if (c !== undefined && c !== null) {
            c.index = this.application.priorStudies.indexOf(c);
        }
        this.$log.debug("addCourse");
        this.$uibModal.open({
            component: "priorStudy",
            backdrop: 'static',
            keyboard: false,
            resolve: {
                application: () => this.application,
                priorStudy: () => c
            }
        }).result.then((priorStudy: PriorCourse) => {
            this.$log.debug(priorStudy);
            if (priorStudy.index !== undefined && priorStudy.index !== null) {
                this.application.priorStudies[priorStudy.index] = priorStudy;
            } else {
                this.application.priorStudies.push(priorStudy);
            }


            if (this.application.id !== undefined && this.application.id !== null && this.application.status !== "DRAFTED") {
                this.savePriorStudies();
                this.newInstitutionAlertShown = !c.institution;
            }
        }, (reason) => {
            this.$log.debug(reason);
        });
    }


    public addCourse() {
        this.LaunchCourseSelector(null);
    }

    public editCourse(course: MonashCourse) {
        this.LaunchCourseSelector(course);
    }

    public deleteCourse(course: MonashCourse) {
        this.application.coursesApplied.splice(this.application.coursesApplied.indexOf(course), 1);
        if (this.application.coursesApplied.length > 0) {
            //if save previously
            if (this.application.id) {
                this.updateStudentCoursePreference();
            }
        }
    }

    public LaunchCourseSelector(course: MonashCourse) {
        this.$log.debug("addCourse");
        this.$uibModal.open({
            component: "courseSelector",
            backdrop: 'static',
            keyboard: false,
            resolve: {
                application: () => this.application,
                currentCourses: () => this.application.coursesApplied,
                courseApplied: () => course,
                user: this.currentUser
                //  teachingPeriods: () => this.teachingPeriods,

            }
        }).result.then((returnedCourse) => {
            this.$log.debug(returnedCourse);

            if (this.checkExistingCourse(returnedCourse.courseCode)) {
                this.selectedCourse = returnedCourse;
            } else {
                this.application.coursesApplied.push(returnedCourse);

                //if save previously
                if (this.application.id) {
                    this.updateStudentCoursePreference();
                }
            }
        }, (reason) => {
            //   this.$log.debug("getStudentModal dismissed: " + reason);
        });
    }

    public checkExistingCourse(code) {
        if (this.application.coursesApplied === undefined) {
            this.application.coursesApplied = [];
        }
        const containsCourse = this.application.coursesApplied.some((course) => {
            return code === course.courseCode;
        });

        return containsCourse;
    }


    public showAssessments() {
        this.asideContent = "ASSESSMENTS";
    }

    public showComments() {
        this.asideContent = "COMMENTS";
    }

    public enableApplicationApproval(): WidgetEnabledState {
        const numApproved = this.assessments
            .filter((assessment) => assessment.status === "APPROVED")
            .length;

        const numInProgress = this.assessments
            .filter((assessment) => assessment.status === "IN_PROGRESS")
            .length;

        const approveEnabled = new WidgetEnabledState();

        if (this.application.status !== "SUBMITTED" && this.application.status !== "UNDER_ASSESSMENT" && this.application.status !== "SUBMITTED_WITH_ADMISSIONS") {
            approveEnabled.message = "Application can't be Approved in current state";
            approveEnabled.enabled = false;
        } else if (numInProgress !== 0) {
            approveEnabled.message = "Application can’t be Approved until all Assessments are accepted";
            approveEnabled.enabled = false;
        } else if (numApproved < 1) {
            approveEnabled.message = "Application can’t be Approved until at least one Assessment is approved";
            approveEnabled.enabled = false;
        } else {
            approveEnabled.message = "Click to approve Application";
            approveEnabled.enabled = this.currentUser.isFacultyAdmin() || this.currentUser.isCentralAdmissions;
        }

        return approveEnabled;
    }


    public addNewAppliedCourse() {
        if (this.application.coursesApplied == null) {
            this.application.coursesApplied = [];
        }

        this.application.coursesApplied.push(new MonashCourse());
    }


    public isStaff() {
        return this.currentUser.isStaff;
    }

    public saveInternalUseOnlyDocuments(attachments) {
        if (this.application.id !== undefined && this.application.id !== null && this.application.status !== "DRAFTED") {
            this.loadingService.show();
            this.processing = true;


            this.applicationService.saveInternalUseOnlyDocuments(this.application.id, attachments)
                .then((updatedApplication) => {
                    this.$log.debug("updatedApplication:", updatedApplication);
                    this.editDisabled = true;
                    this.isAllowAddCoursesByStudent = false;

                    this.toaster.pop({type: "success", title: "Internal use documents saved successfully"});

                    this.$state.reload();
                })
                .finally(() => {
                        this.processing = false;
                        this.loadingService.hide();
                    }
                );
        }
    }


    public saveSupportingDocuments(attachments) {
        if (this.application.id !== undefined && this.application.id !== null && this.application.status !== "DRAFTED") {
            this.loadingService.show();
            this.processing = true;


            this.applicationService.saveSupportingDocuments(this.application.id, attachments)
                .then((updatedApplication) => {
                    this.$log.debug("updatedApplication:", updatedApplication);
                    this.editDisabled = true;
                    this.isAllowAddCoursesByStudent = false;

                    this.toaster.pop({type: "success", title: "Documents saved successfully"});

                    this.$state.reload();
                })
                .finally(() => {
                        this.processing = false;
                        this.loadingService.hide();
                    }
                );
        }
    }

    public getStatusCss() {
        if (this.isSystemAccepted()) {
            return 'accepted';
        } else if (this.isSystemRejected() || this.application.status === 'APPROVED') {
            return 'rejected';
        } else {
            return 'default';
        }
    }

    /**
     * Check if the application status indicates system acceptance.
     */
    public isSystemAccepted(): boolean {
        return checkSystemAccepted(this.application.status);
    }

    /**
     * Check if the application status indicates system rejection.
     */
    public isSystemRejected(): boolean {
        return checkSystemRejected(this.application.status);
    }

    /**
     * Check if the application status is a system-accepted or system-rejected status.
     * Useful for determining if summary tab should be active.
     * @param status - The application status string (optional, defaults to current application status)
     */
    public isSystemAcceptedOrRejected(status?: string): boolean {
        const appStatus = status || this.application.status;
        return checkSystemAccepted(appStatus) || checkSystemRejected(appStatus);
    }

    public ifPriorUnitInAssessment(unit: PriorCourseUnit){
        for (let i = 0; i < this.assessments.length; i++) {
            const ass = this.assessments[i];
            if (ass.priorCourseUnits && ass.priorCourseUnits.filter(u => u.unitId == unit.unitId).length > 0){
                return true;
            }
        }
        return false;
    }

    public resetApplicationStatus() {
        this.$log.debug("resetApplicationStatus:", this.application);
        this.loadingService.show();
        this.processing = true;

        this.applicationService.resetApplicationStatus(this.application)
            .then((updatedApplication) => {
                this.$log.debug("updatedApplication", updatedApplication);
                this.toaster.pop({type: "Success", title: "Student application status reset"});
                this.application = updatedApplication;
            })
            .catch((reason) => {
                this.$log.debug("Failed", reason);
                this.toaster.pop({type: "failure", title: "Failed to reset the application status"});
            })
            .finally(() => {
                this.processing = false;
                this.loadingService.hide();
            });

    }

    public deleteUnit(priorCourse: PriorCourse, unit: PriorCourseUnit) {
        priorCourse.units.splice(priorCourse.units.indexOf(unit), 1);
        this.savePriorStudies();
    }

    public reopenApplication() {
        this.$log.debug("reopenApplication:", this.application);

        this.$uibModal.open({
            component: "applicationReopenModal",
            backdrop: 'static',
            keyboard: false,
            resolve: {
                application: () => this.application
            }
        }).result.then((updatedApplication) => {
            this.$log.info("Application reopened: ", updatedApplication);
            this.application = updatedApplication;

            this.applicationService.getStudentCreditApplicationHistoryByApplicationId(this.application.id)
                .then((applicationHistories) => {
                    this.applicationHistories = applicationHistories;
                });
        }, (reason) => {
            this.$log.info("modal dismissed: " + reason);
        });
    }

    public reallocateFaculty() {
        this.$log.debug("reallocateFaculty:", this.application);

        this.$uibModal.open({
            component: "applicationReallocateFacultyModal",
            backdrop: 'static',
            keyboard: false,
            resolve: {
                application: () => this.application,
                faculties: () => this.facultyService.getFaculties()
            }
        }).result.then((updatedApplication) => {
            this.$log.info("Owning faculty successfully re-allocated: ", updatedApplication);
            this.application = updatedApplication;
        }, (reason) => {
            this.$log.info("modal dismissed: " + reason);
        });
    }

    public approveApplication() {
        this.$log.debug("approveApplication:", this.application);
        this.$uibModal.open({
            component: "applicationApproveModal",
            backdrop: 'static',
            keyboard: false,
            resolve: {
                application: () => this.application,
                currentUser: () => this.currentUser
            }
        }).result.then((updatedApplication) => {
            this.application = updatedApplication;
        }, (reason) => {
            this.$log.info("modal dismissed: " + reason);
        });
    }

    public declineApplication() {
        this.$log.debug("declineApplication:", this.application);
        this.$uibModal.open({
            component: "applicationDeclineModal",
            backdrop: 'static',
            keyboard: false,
            resolve: {
                application: () => this.application
            }
        }).result.then((updatedApplication) => {
            this.application = updatedApplication;
        }, (reason) => {
            this.$log.info("modal dismissed: " + reason);
        });
    }

    public reopenSummary() {
        this.$log.debug("reopenSummary:", this.application);
        this.$uibModal.open({
            component: "applicationReopenSummaryModal",
            backdrop: 'static',
            keyboard: false,
            resolve: {
                application: () => this.application
            }
        }).result.then((updatedApplication) => {
            this.application = updatedApplication;
        }, (reason) => {
            this.$log.info("modal dismissed: " + reason);
        });
    }

    public submitApplication() {
        this.$log.debug("submitting Application:", this.application);

        if (!this.validateUnitAttachmentsAndLinks() || !this.validateSupportingLinks() ||
            !this.validateCourseSelected() || this.form.$invalid) {
            this.showErrors = true;

            this.toaster.pop({
                type: "error",
                title: "Submission failed. Please address highlighted form errors before submitting."
            });
            return;
        }
        this.loadingService.show();
        this.processing = true;

        this.cleanseApplication(this.application);

        this.applicationService.submitStudentCreditRequest(this.application)
            .then((submittedApplication) => {
                this.$log.debug("submittedApplication:", submittedApplication);
                this.editDisabled = true;
                this.isAllowAddCoursesByStudent = false;
                this.toaster.pop({type: "success", title: "Application submitted successfully"});

                if (this.currentUser.isStaff && !this.studentMode) {
                    this.$state.go("staff.dashboard");
                } else {
                    this.$state.go("student.dashboard");
                }
            })
            .finally(() => {
                    this.processing = false;
                    this.loadingService.hide();
                }
            )
        ;
    }

    public saveApplicationAsDraft() {
        this.processing = true;
        this.loadingService.show();

        this.cleanseApplication(this.application);

        this.applicationService.saveStudentCreditRequestAsDraft(this.application)
            .then((draftedApplication) => {
                this.$log.debug("saveStudentCreditRequestAsDraft:", draftedApplication);
                this.application = draftedApplication;
                this.editDisabled = false;
                this.isAllowAddCoursesByStudent = true;
                this.toaster.pop({type: "success", title: "Application saved successfully"});

                if (this.studentMode) {
                    this.$state.go("student.application", {applicationId: draftedApplication.id});
                } else {
                    this.$state.go("staff.edit", {id: draftedApplication.id});
                }
            })
            .finally(() => {
                this.processing = false;
                this.loadingService.hide();
            });
    }

    public debugPrefillFormData(): void {
        this.application = Application.createDummyApplication(this.application);
        this.$log.debug("this.application is %o", this.application);
    }

    public debugPrefillForm() {
        if (this.$scope.$$phase) { // most of the time it is "$digest"
            this.debugPrefillFormData();
        } else {
            this.$scope.$apply(this.debugPrefillFormData);
        }
    }

    public updateStudentEmail() {
        this.applicationService.updateStudentEmail(this.application, this.application.applicant.email).then((updatedApplication) => {
            this.$log.debug("updateStudentEmail: %s", updatedApplication);
            this.application = updatedApplication;
            this.toaster.pop({type: "success", title: "Student email updated successfully"});
        }).finally(() => {
            this.processing = false;
            this.loadingService.hide();
        });
    }

    public updateStudentPhone() {
        this.applicationService.updateStudentPhone(this.application).then((updatedApplication) => {
            this.$log.debug("updateStudentPhone: %s", updatedApplication);
            this.application = updatedApplication;
            this.toaster.pop({type: "success", title: "Student phone updated successfully"});
        }).finally(() => {
            this.processing = false;
            this.loadingService.hide();
        });
    }

    public updateStudentCoursePreference() {
        if (this.application.id === undefined || this.application.id === null) {
            return;
        }
        this.applicationService.updateStudentCoursePreference(this.application, this.application.coursesApplied).then((updatedApplication) => {
            this.$log.debug("updateStudentCoursePreference: %s", updatedApplication);
            this.application = updatedApplication;
            let title = "Student course preference updated successfully.";
            if (this.application.isOnlineCourse) {
                title += " This application contains Online Course and it will only appear in Monash Online team dashboard.";
            }
            this.toaster.pop({type: "success", title: title});
        }).finally(() => {
            this.processing = false;
            this.loadingService.hide();
        });
    }

    public getSupportingLinksIndexSize() {
        if (this.application.supportingLinks[this.application.supportingLinks.length - 1] !== null) {
            for (let i = this.linkIndexArray.length - 1; i < this.application.supportingLinks.length; i++) {
                this.linkIndexArray.push(this.application.supportingLinks.length + 1);
            }
        }
    }

    public updateCreditPoints() {
        this.$log.info("UpdateCreditPoints", this.assessments);
        if (!this.assessments || this.assessments.length <= 0) {
            this.creditPointsApproved = 0;
            this.creditPointsAccepted = 0;
            return;
        }
        this.creditPointsApproved = this.sumApprovedCredits(this.assessments);
        this.creditPointsAccepted = this.sumApprovedCredits(this.assessments.filter((assessment) => assessment.studentAccepted));

        this.calculateCreditSummary();
    }

    /***
     * Calculate the credit summary for approved assessments
     * The summary is for SPECIFIED and UNSPECIFIED credits in each course selected
     */
    public calculateCreditSummary(){
        this.approvedAssessmentsCreditSummary = new Array();
        let courses = new Array();
        for (let i = 0; i < this.assessments.length; i++) {
            const assessment = this.assessments[i];
            if (assessment.status != "APPROVED") {
                // only summarise the credit points for those approved assessments
                continue;
            }
            const credits = assessment.credits;
            let summary;
            assessment.courseCodes.forEach((code) => {// e.g. ['L3011-', 'L3002-major']
                code = code.split('-',1)[0];

                if (this.approvedAssessmentsCreditSummary.length == 0
                    || this.approvedAssessmentsCreditSummary.filter((s) => code == s.courseCode).length == 0) {
                    // create new if no existing summary for this course
                    summary = new CreditSummary();
                    summary.courseCode = code;
                    this.approvedAssessmentsCreditSummary.push(summary);
                } else {
                    summary = this.approvedAssessmentsCreditSummary.filter((s) => code == s.courseCode)[0];
                }
                if (this.application.applicant.creditRecords){
                    this.application.applicant.creditRecords
                        .filter((c) => c.courseCode == code)
                        .filter( c => c.grantingStatus == "APPROVED" || c.grantingStatus == "GRANTED")
                        .forEach(exist => {
                            console.log("exist record ||||||")
                            console.log(exist);
                            // logic of "courses.indexOf(code) == -1" as explained below:
                            // if one course appears in more than one assessment, calculate only once for the same course
                            // because the "previously granted/approved points" remain the same no matter the number of assessments
                            if (exist.creditType == 'specifiedCredit' && courses.indexOf(code) == -1){
                                console.log('specified existing credit ======' + exist.systemCreditPoints);
                                summary.grantedOrApprovedInCallistaSpecified += exist.systemCreditPoints
                            } else if (exist.creditType === 'unspecifiedCredit' && courses.indexOf(code) == -1){
                                console.log('unspecified existing credit ====== ' + exist.systemCreditPoints + ' for course ' + code);
                                summary.grantedOrApprovedInCallistaUnspecified += exist.systemCreditPoints
                            }
                        });
                }
                if (courses.indexOf(code) == -1){
                    courses.push(code);
                }

                // credits in assessments
                for (const credit of credits) {
                    if (credit.type == 'SPECIFIED_CREDIT' && credit.specifiedCreditType !== "PRECLUSION") {
                        summary.specifiedCreditsInApplication += credit.creditPoints;
                        if (assessment.studentAccepted){
                            summary.specifiedAcceptedByStudent += credit.creditPoints;
                        }
                    } else if (credit.type == 'UNSPECIFIED_CREDIT') {
                        summary.unspecifiedCreditsInApplication += credit.creditPoints;
                        if (assessment.studentAccepted){
                            summary.unspecifiedAcceptedByStudent += credit.creditPoints;
                        }
                    }
                }

                if (!checkSystemAccepted(this.application.status) || this.application.isPendingStudentAction === true){
                    summary.totalToBeRecordedInInCallistaSpecified = summary.grantedOrApprovedInCallistaSpecified + summary.specifiedCreditsInApplication;
                    summary.totalToBeRecordedInInCallistaUnspecified = summary.grantedOrApprovedInCallistaUnspecified + summary.unspecifiedCreditsInApplication;
                } else {
                    summary.totalToBeRecordedInInCallistaSpecified = summary.grantedOrApprovedInCallistaSpecified + summary.specifiedAcceptedByStudent;
                    summary.totalToBeRecordedInInCallistaUnspecified =  summary.grantedOrApprovedInCallistaUnspecified + summary.unspecifiedAcceptedByStudent;
                }
            });
        }
        console.log("credit summaries")
        console.log(this.approvedAssessmentsCreditSummary);
    }

    public openCreditInfoBox() {
        this.$uibModal.open({
            component: "infoModal",
            resolve: {
                title: () => "Credit",
                content: () => "Awarded credit points for previous study towards units that you will not be required to complete towards your degree."
            }
        });
    }

    public openPreclusionInfoBox() {
        this.$uibModal.open({
            component: "infoModal",
            resolve: {
                title: () => "Preclusion or Exemption",
                content: () => "Not awarded credit points; you are required to replace these units with alternative units."
            }
        });
    }

    private sumApprovedCredits(assessments: Assessment[]): number {
        return assessments
            .filter((assessment) => assessment.status === "APPROVED")
            .reduce((res, cur) => cur.credits.concat(res), [])  // FlatMap
            .filter((credit) => credit.specifiedCreditType !== "PRECLUSION")  // Preclusion's don't count.
            .reduce((count, credit) => count + credit.creditPoints, 0);
    }

    private checkAttachmentDuplicates(currentAttachments, newAttachment) {
        return newAttachment && currentAttachments.some((item) => {
            return item.filename === newAttachment.filename;
        });
    }

    private unitContainsAttachment(unit: PriorCourseUnit, attachment) {
        return attachment && unit.supportingDocuments.some((item) => {
            return item.id === attachment.id;
        });
    }

    private copyApplicationAttachments() {
        this.supportingDocuments.forEach((doc) => {
            if (!this.checkAttachmentDuplicates(this.application.supportingDocuments, doc)) {
                this.application.supportingDocuments = this.application.supportingDocuments.concat(doc);
            }
        });
        this.supportingDocuments.splice(0, this.supportingDocuments.length);
        this.supportingDocumentsQueue.splice(0, this.supportingDocumentsQueue.length);
    }

    private copyInternalUseOnlyAttachments(): any[] {
        const newDocs = [];
        this.internalUseOnlyDocuments.forEach((doc) => {
            if (!this.checkAttachmentDuplicates(this.application.internalUseOnlyDocuments, doc)) {
                this.application.internalUseOnlyDocuments = this.application.internalUseOnlyDocuments.concat(doc);
            }
        });
        this.internalUseOnlyDocuments.splice(0, this.internalUseOnlyDocuments.length);
        this.internalUseOnlyDocumentsQueue.splice(0, this.internalUseOnlyDocumentsQueue.length);
        return newDocs;
    }

    private copyUnitAttachments() {
        //flatten application's units (from studies they are nested into)
        const flatUnits = _.mapKeys(
            _.flatten(_.map(this.application.priorStudies, "units")), (value: any, key) => value.unitId);

        _.forIn(this.unitDocumentsQueue, (queueObject: any, unitId) => {
            queueObject.splice(0, queueObject.length);
        });
        _.forIn(this.unitDocumentsNewAttachments, (attachments: any, unitId) => {
            attachments.forEach((attachment) => {
                if (!this.unitContainsAttachment(flatUnits[unitId], attachment)) {
                    flatUnits[unitId].supportingDocuments = flatUnits[unitId].supportingDocuments.concat(attachment);
                }
            });
            attachments.splice(0, attachments.length);
        });
        this.$log.log("Application with populated unit documents: %o", this.application);
    }

    private cleanseApplication(application: Application): Application {
        this.copyApplicationAttachments();
        // this.copyUnitAttachments();
        this.copyInternalUseOnlyAttachments();
        //this.copyInternalUseOnlyAttachments();
        const cleanseSupportingLinks = (supportingLinks: string[]): string[] => {
            return supportingLinks
                .filter((link: string) => !!link)
                .map((link: string) => {
                    link = link.trim();
                    return link.indexOf("http") === 0 ? link : "http://".concat(link);
                });
        };

        const cleansePriorCourseUnit = (unit: PriorCourseUnit): PriorCourseUnit => {
            unit.supportingLinks = cleanseSupportingLinks(unit.supportingLinks);
            return unit;
        };

        const cleansePriorCourse = (priorStudy: PriorCourse): PriorCourse => {
            priorStudy.units = priorStudy.units.map(cleansePriorCourseUnit);
            return priorStudy;
        };

        application.supportingLinks = cleanseSupportingLinks(application.supportingLinks);
        const updatedApplication = angular.copy(application);
        updatedApplication.priorStudies = application.priorStudies.map(cleansePriorCourse);

        return updatedApplication;
    }

    private validateUnitAttachmentsAndLinks(): boolean {
        const isValid = this.application.supportingDocuments.length > 0 || (this.supportingDocumentsQueue.length > 0) || this.hasNonEmptyLinks(this.application.supportingLinks);

        this.linksValid = isValid;
        return isValid;
    }

    private validateSupportingLinks(): boolean {
        let isValid = true;
        this.application.supportingLinks.forEach((link) => {
            if (!_.isEmpty(link) && !_.startsWith(link, "http", 0) && !_.startsWith(link, "https", 0)) {
                isValid = false;
            }
        });
        this.linksFormatValid = isValid;
        return isValid;
    }

    private validateCourseSelected(): boolean {
        let isValid = true;
        if (!this.application.coursesApplied || this.application.coursesApplied.length == 0){
            isValid = false;
        }
        this.appliedCourseValid = isValid;
        return isValid;
    }

    private hasNonEmptyLinks(supportingLinks: string[]): boolean {
        if (supportingLinks.length > 0) {
            return _.some(supportingLinks, (link) => {
                return !_.isEmpty(_.trim(link));
            });
        } else {
            return false;
        }
    }
}

export default ApplicationController;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/application.controller.ts